import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN } from '../../../../../define/consts/proffit_search/proffit_search_service';
import { isGuest } from '../../../../../helpers/auth';
import { propBool, propStr, propFunc, } from '../../../../../helpers/custom-prop-types';
import LockIcon from '../../../../Icon/Svg/LockIcon';
import PictureFrameIcon from '../../../../Icon/Svg/PictureFrameIcon';
import PlusIcon from '../../../../Icon/Svg/PlusIcon';
import HtmlLink from '../../../../Ui/Common/HtmlLink';
import Tooltip from '../../../../Ui/Tooltip/Tooltip';
const SlideAddButton = (props) => {
    const { className, disabled, onClickLockItem } = props;
    // ゲストの場合はスライド追加ボタン非表示
    const auth = useSelector((state) => state.auth);
    if (isGuest(auth)) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: className }, { children: _jsx("div", Object.assign({ className: 'my_slide_add_btn_wrapper' }, { children: _jsxs("div", Object.assign({ className: 'my_slide_add_btn_box' }, { children: [disabled && (_jsx("div", Object.assign({ className: 'my_slide_add_btn_lock' }, { children: _jsx(Tooltip, Object.assign({ html: _jsx("div", { children: PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN }), zIndex: 1011 }, { children: _jsx(HtmlLink, Object.assign({ isNoLinkComponent: onClickLockItem ? 'button' : undefined, onClick: onClickLockItem, to: '/proffit_search/account_plan' }, { children: _jsx(LockIcon, {}) })) })) }))), _jsx(HtmlLink, Object.assign({ className: clsx('my_slide_add_btn', disabled && 'is-disabled'), isNoLinkComponent: disabled ? 'div' : undefined, to: '/proffit_search/slide_add' }, { children: _jsxs("div", Object.assign({ className: 'add_slide_inner' }, { children: [_jsxs("div", Object.assign({ className: 'add_slide_icons' }, { children: [_jsx(PictureFrameIcon, {}), _jsx(PlusIcon, {})] })), _jsxs("div", Object.assign({ className: 'add_slide_text' }, { children: [_jsx("span", { children: "\u307E\u3068\u3081\u3066" }), _jsx("span", { children: "\u30B9\u30C8\u30C3\u30AF" })] }))] })) }))] })) })) })));
};
SlideAddButton.propTypes = {
    className: propStr(),
    disabled: propBool().isRequired,
    onClickLockItem: propFunc(),
};
SlideAddButton.defaultProps = {
    className: '',
    onClickLockItem: undefined,
};
export default SlideAddButton;
